import { Component } from '@angular/core';
import packageJson from '../../../../../package.json'
// import package from '../package.json'

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {

  currentYear = new Date().getFullYear()
  version = packageJson.version

}
